import React from "react";
import { fillingSettingService } from "../../api";
import { alertError, confirm2, enums, notifySuccess, today } from "../../base";
import { ContentBlock, StdToolbar } from "../../components";
import { FillingSettingModel } from "../../models";
import AuthorizedComponent from "../authorized-component";
import FillingSettingForm from "./filling-setting-form";
import FillingSettingGrid from "./filling-setting-grid";

export default class FillingSettingPage extends AuthorizedComponent {
    objectName = "FillingSetting";
    gridRef = React.createRef<FillingSettingGrid>();
    formRef = React.createRef<FillingSettingForm>();
    toolbarRef = React.createRef<StdToolbar>();

    constructor(props: Readonly<any>) {
        super(props);

        this.onModelSelected = this.onModelSelected.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.onSaved = this.onSaved.bind(this);
    }

    onModelSelected(model: FillingSettingModel) {
        this.toolbarRef.current?.setModel(model);
    }

    onButtonClick(model: FillingSettingModel, name: string) {
        switch (name) {
            case "edit":
                if (this.permissions[enums.stdActions.update]) {
                    this.formRef.current?.show(model);
                }
                break;

            case "add":
                if (this.permissions[enums.stdActions.create]) {
                    this.formRef.current?.show({ settingDate: today() });
                }
                break;

            case "delete":
                if (this.permissions[enums.stdActions.delete]) {
                    this.delete(model);
                }
                break;
        }
    }

    onSaved() {
        this.gridRef.current &&
            this.gridRef.current.gridRef.current?.instance.refresh();
    }

    async delete(model: FillingSettingModel) {
        if (!await confirm2("确定要删除吗？")) {
            return;
        }

        const res = await fillingSettingService.delete(model.id!);

        if (res.succeeded) {
            this.gridRef.current?.refresh();
            notifySuccess("成功删除记录");
        } else {
            alertError(res.message!);
        }
    }

    render() {
        return (
            <ContentBlock caption={"充装设置"}>
                <StdToolbar 
                    permissions={this.permissions}
                    ref={this.toolbarRef} 
                    onButtonClick={this.onButtonClick} />
                <FillingSettingGrid
                    ref={this.gridRef}
                    onModelSelected={this.onModelSelected}
                    onButtonClick={this.onButtonClick} />
                <FillingSettingForm ref={this.formRef} onSaved={this.onSaved} />
            </ContentBlock>
        );
    }
}